import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  constructor(
    private http: HttpClient
  ) { }

  getIpAddress() {
    return this.http.get<{ ip: string }>(`${environment.apiURL}/admin/ipAddress`);
  }

  getSecurityDetails() {
    return this.http.get(`${environment.apiURL}/admin/security/details`);
  }

  addUpdateSecurityRules(payload: any) {
    return this.http.put(`${environment.apiURL}/admin/security/details`, payload);
  }

  deleteSecurityRules(securityId: string, ip: string) {
    let url = `${environment.apiURL}/admin/security?securityId=${securityId}`;
    if (ip) {
      url = `${url}&ip=${ip}`
    }
    return this.http.delete(url);
  }

  enableDisableMFa(status: boolean) {
    return this.http.put(`${environment.apiURL}/admin/mfa/status`, { status });
  }

  getAdminMfaMandatory() {
    return this.http.get(`${environment.apiURL}/admin/mfa/mandatory`);
  }

  setAdminMfaMandatory(status: boolean) {
    // Super-admin only; non-super-admins get 403.
    return this.http.put(`${environment.apiURL}/admin/mfa/mandatory`, { status });
  }

  enableDisableAdvanceSecurity(status: boolean) {
    return this.http.put(`${environment.apiURL}/admin/security/status`, { status });
  }

  mfaSetup(password?: string) {
    const payload = password ? { password } : {};
    return this.http.post(`${environment.apiURL}/admin/mfa/setup`, payload);
  }

  verifyMfa(userToken: string) {
    return this.http.put(`${environment.apiURL}/admin/mfa/verify`, { userToken });
  }

  verifyUserMfa(userToken: string) {
    return this.http.put(`${environment.apiURL}/admin/verify/mfa`, { userToken });
  }

  deleteMfaSetup(payload: { otp?: string; hash?: string } = {}) {
    return this.http.delete(`${environment.apiURL}/admin/mfa/setup`, { body: payload });
  }

  getMfaReport() {
    return this.http.get(`${environment.apiURL}/admin/mfa/report`);
  }

  getMfaReportDetails(userType: string, page: number, limit: number) {
    const params = new HttpParams()
      .set('userType', userType)
      .set('page', page)
      .set('limit', limit);
    return this.http.get(`${environment.apiURL}/admin/mfa/report/details`, { params });
  }
}
